module.exports = __webpack_public_path__ + "media/images/checkout-step-background-a2bf27de25417850a334a916c9a0ec72.png";